export default __webpack_public_path__ + "static/media/Gloves of Intricate Spite.f9c07135.jpg";